import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Timer } from "lucide-react";
import { api, toastApiError } from "@/lib/api";

const left = (expiry, now) => Math.max(0, Number(expiry || 0) - now);
const fmt = (s) => (s >= 3600 ? `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m` : `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`);

export const OpenTrades = ({ auth, onSold }) => {
  const [rows, setRows] = useState([]);
  const [now, setNow] = useState(Math.floor(Date.now() / 1000));
  const [selling, setSelling] = useState(null);

  useEffect(() => {
    const pull = () => api.get("/account/open-contracts", { params: { session_id: auth.session_id, account_id: auth.account_id } })
      .then((r) => setRows(r.data.contracts || [])).catch(() => {});
    pull();
    const p = setInterval(pull, 10000);
    const t = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => { clearInterval(p); clearInterval(t); };
  }, [auth.session_id, auth.account_id]);

  const sell = async (cid) => {
    setSelling(cid);
    try {
      const r = await api.post("/account/sell", { session_id: auth.session_id, account_id: auth.account_id, contract_id: cid });
      toast.success(`Sold #${cid} for $${Number(r.data.sell?.sold_for || 0).toFixed(2)}`);
      setRows((xs) => xs.filter((x) => x.contract_id !== cid));
      onSold && onSold();
    } catch (e) { toastApiError(toast, e, "Could not sell this contract now"); } finally { setSelling(null); }
  };

  if (!rows.length) return null;
  return (
    <section className="casino-frame rounded-2xl p-5 mt-6" data-testid="open-trades">
      <div className="flex items-center gap-2"><Timer className="h-5 w-5 text-gold" /><h3 className="font-casino text-xl text-gold-grad">Open trades</h3>
        <span className="marquee-badge ml-2">{rows.length} LIVE</span></div>
      <div className="mt-4 space-y-2">
        {rows.map((c) => (
          <div key={c.contract_id} className="rounded-xl border border-gold/20 bg-black/40 px-4 py-3 flex flex-wrap items-center justify-between gap-3" data-testid={`open-trade-${c.contract_id}`}>
            <div className="min-w-0">
              <div className="text-sm text-white/85 truncate max-w-[520px]">{c.longcode || c.contract_type}</div>
              <div className="font-mono-naevo text-[10px] text-white/40">#{c.contract_id} · stake ${Number(c.buy_price || 0).toFixed(2)} · pays ${Number(c.payout || 0).toFixed(2)}</div>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-mono-naevo text-gold text-lg" data-testid={`open-trade-countdown-${c.contract_id}`}>{fmt(left(c.expiry_time, now))}</span>
              <button onClick={() => sell(c.contract_id)} disabled={selling === c.contract_id} className="btn-velvet rounded-full px-4 py-1.5 text-xs" data-testid={`open-trade-sell-${c.contract_id}`}>
                {selling === c.contract_id ? "Selling…" : "Sell now"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
